<template>
  <component
    class="content"
    :class="`content--${content.id}`"
    :is="instance"
    :baseWidth="baseWidth"
    :baseHeight="baseHeight"
    :content="content"
    :config="config"
    :style="styles"
    v-on="$listeners"
    @click.native="performAction"
  />
</template>

<script>
import contentComponent from "@/mixins/content";

export default {
  mixins: [contentComponent],

  computed: {
    instance() {
      return () => import(`@/components/content/${this.content.type}`);
    },
  },

  methods: {
    performAction() {
      this.content?.action && this.$emit(this.content?.action);
    },
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
.content {
  position: absolute;
}
</style>
